/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'back': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<g _stroke="none" stroke-width="1" _fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round"><g transform="translate(10 12)" _stroke="#000"><path pid="0" d="M11.919 4H0"/><polyline pid="1" points="4 8 0 4 4 0"/></g></g>'
  }
})



// WEBPACK FOOTER //
// ./src/assets/icons/back.js